var _path, _path2, _path3, _path4, _rect, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSourceOfFundsCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 19H4C2.895 19 2 18.105 2 17V7C2 5.895 2.895 5 4 5H20C21.105 5 22 5.895 22 7V17C22 18.105 21.105 19 20 19Z",
    fill: "#3158F2",
    stroke: "#3158F2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.999 11.8628C17.792 11.8638 17.625 12.0318 17.625 12.2388C17.625 12.4458 17.793 12.6138 18 12.6128C18.207 12.6128 18.375 12.4448 18.375 12.2378C18.375 12.0308 18.207 11.8628 17.999 11.8628",
    stroke: "#E4E7EC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.999 11.8628C5.792 11.8638 5.625 12.0318 5.625 12.2388C5.625 12.4458 5.793 12.6138 6 12.6128C6.207 12.6128 6.375 12.4448 6.375 12.2378C6.375 12.0308 6.207 11.8628 5.999 11.8628",
    stroke: "#E4E7EC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7678 10.2322C14.7441 11.2085 14.7441 12.7915 13.7678 13.7678C12.7915 14.7441 11.2085 14.7441 10.2322 13.7678C9.25592 12.7915 9.25592 11.2085 10.2322 10.2322C11.2085 9.25592 12.7915 9.25592 13.7678 10.2322",
    stroke: "#E4E7EC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 14,
    width: 7.99909,
    height: 9.06876,
    rx: 2.33905,
    fill: "#3158F2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18 18.6782C18 19.5398 19.7449 20.2376 21.8984 20.2376C24.0519 20.2376 25.7968 19.5398 25.7968 18.6782",
    stroke: "#E4E7EC",
    strokeWidth: 1.16952,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18 15.5596C18 16.4211 19.7449 17.1189 21.8984 17.1189C24.0519 17.1189 25.7968 16.4211 25.7968 15.5596",
    stroke: "#E4E7EC",
    strokeWidth: 1.16952,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8969 14C19.7449 14 17.9984 14.6978 18 15.5594",
    stroke: "#E4E7EC",
    strokeWidth: 1.16952,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18 15.5596V21.797C18 22.6586 19.7449 23.3564 21.8984 23.3564",
    stroke: "#E4E7EC",
    strokeWidth: 1.16952,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8984 14C24.0504 14 25.7969 14.6978 25.7953 15.5594",
    stroke: "#E4E7EC",
    strokeWidth: 1.16952,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7969 15.5596V21.797C25.7969 22.6586 24.0519 23.3564 21.8984 23.3564",
    stroke: "#E4E7EC",
    strokeWidth: 1.16952,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSourceOfFundsCheck);
export default __webpack_public_path__ + "static/media/source_of_funds_check.5cf8c24af3815c6863a1d7a066851da2.svg";
export { ForwardRef as ReactComponent };